import type { LegacyConfig } from '@debatdirect/common/types/legacy-config';

const playerUrl = __PLAYER_URL__ || import.meta.env.APP_THEOPLAYER_URL;
const license = __PLAYER_LICENSE__ || '';

export default {
  api: {
    enabled: true,
    baseUrl: import.meta.env.APP_API_BASE_URL || '',
    cdnBaseUrl: import.meta.env.APP_CDN_BASE_URL || '',
  },
  liveApi: {
    enabled: true,
    url: import.meta.env.APP_LIVE_URL,
    // worker: '/static/js/worker.js',
    maxDelay: 300000,
    interval: 250,
    maxAge: 900000,
  },
  social: {
    facebookAppId: import.meta.env.APP_FACEBOOK_APP_ID,
  },
  fragments: {
    url: import.meta.env.APP_STREAM_SHARE_URL,
    eventAddToEndSeconds: 5,
    eventSubtractFromStartSeconds: 0,
  },
  theoplayer: {
    url: playerUrl,
    license,
  },
  chromecast: {
    gStaticUrl: import.meta.env.APP_CHROMECAST_GSTATIC_URL,
    appId: import.meta.env.APP_CHROMECAST_APPLICATION_ID,
  },
  stats: {
    baseUrl: import.meta.env.APP_PIWIK_URL,
  },
  auth: {
    clientId: import.meta.env.APP_AUTH_CLIENT_ID,
    userPoolId: import.meta.env.APP_AUTH_USER_POOL_ID,
    region: import.meta.env.APP_AUTH_REGION,
    identityPoolId: import.meta.env.APP_AUTH_IDENTITY_POOL_ID,
    mxfBucket: import.meta.env.APP_AUTH_MXF_BUCKET,
  },
  share: {
    url: import.meta.env.APP_BASE_URL,
  },
  date: {
    fromDate: import.meta.env.APP_DATE_FROM_DATE,
  },
  staticUrl: import.meta.env.APP_STATIC_URL,
  baseUrl: import.meta.env.APP_BASE_URL || '',
  dateLimit: {
    downloadUnmarkedDebateFromDate: new Date(import.meta.env.APP_FEATURE_DOWNLOAD_UNMARKED_DEBATE_FROM_DATE || '1970-01-01'),
    downloadFragmentDebateFromDate: new Date(import.meta.env.APP_FEATURE_DOWNLOAD_FRAGMENT_DEBATE_FROM_DATE || '1970-01-01'),
  },
  licensesPageEnabled: import.meta.env.APP_ENABLE_LICENSES_PAGE,
} satisfies LegacyConfig;
